export default __webpack_public_path__ + "static/marketing-adornment-92c9b27de8839e0384287f55af175d17.svg";